import { render } from "./confirm_hotel_rate_change.vue?vue&type=template&id=0990c846"
import script from "./confirm_hotel_rate_change.vue?vue&type=script&lang=js"
export * from "./confirm_hotel_rate_change.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__